import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import Banner from '../partials/Banner';
import i from '../imports';
import c from '../components';
import { Redirect } from 'react-router';

import { compose, withProps, withStateHandlers, withState, lifecycle } from "recompose"
import { FusionTablesLayer  } from "react-google-maps";
  
import { InfoBox, InfoWindow } from "react-google-maps/lib/components/addons/InfoBox"

import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker
} from "react-google-maps";
import { relative } from 'path';

//const destinations = Session.model.destinations;

//ВАЖНО!! не удалять!!! Api key for this: 
//AIzaSyChSiXc1Cyprcrhw2Unu1e1jXKMf1Cx1qo

class InfoWindowMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            redirect: false
        }
    }

    handleToggleOpen = (event) => {
        this.setState({
            isOpen: true
        });
    }

    handleToggleClose = (event) => {
        this.setState({
            isOpen: false
        });
    }

    handleClick = (event) => {
        this.setState({ redirect: true });
    }
    render() {
        if (this.state.redirect) {
            return <Redirect push to={this.props.url} />;
        }
        let item = this.props.item;
        let width = window.width;
        return (
            <Marker
                key={this.props.index}
                position={this.props.position}
                clickable={true}
                // label={this.props.title}
                onMouseOver={this.handleToggleOpen}
                onMouseOut={this.handleToggleClose}
                onMouseDown={this.handleClick}
            >
                {
                    this.state.isOpen &&
                    <InfoBox
                        style={{ padding: 0 }}
                        options={{ closeBoxURL: ``, enableEventPropagation: true }}
                    >
                        <div style={{ width: 400, padding: 0 }}>
                            <c.Card
                                style={{ margin: 10 }}
                                key={this.props.index}
                                title={item.translations[0].title}
                                url='#'
                                priceFrom={item.price}
                                background={item.pic}
                            > {item.translations[0].short_text}
                            </c.Card>
                        </div>
                    </InfoBox>

                }
            </Marker>

        )
    }
}


const MapWithAMarker = compose(
    withProps({
        googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyChSiXc1Cyprcrhw2Unu1e1jXKMf1Cx1qo&callback=initMap',
        containerElement: <div style={{ height: `500px` }} />,
        mapElement: <div style={{ height: `100%` }} />,
        loadingElement: <div>Loading...</div>,
    }),
    // withStateHandlers(() => ({
    //     isOpen: false,
    // }), {
    //         onFit: ({ isOpen }) => () => ({
    //             isOpen: !isOpen,
    //         })
    //     }),

    lifecycle({
        componentWillMount() {
            this.setState({
                zoomToMarkers: map => {
                    const bounds = new window.google.maps.LatLngBounds();
                    if (map) {
                        bounds.extend(new window.google.maps.LatLng(76, 60))
                        bounds.extend(new window.google.maps.LatLng(48, 48))
                        bounds.extend(new window.google.maps.LatLng(55, 20))
                        bounds.extend(new window.google.maps.LatLng(66, 170))
                        map.fitBounds(bounds);
                    }
                }
            })
        },
    }),
    withScriptjs,
    withGoogleMap
)((props) =>
    <GoogleMap
        // panTo={{lat: 25.0112183,lng: 121.52067570000001}}
        ref={props.zoomToMarkers}
        defaultZoom={Number.parseFloat(props.destinations.start_location_and_scale.scale)}
        defaultCenter={{
            lat: Number.parseFloat(props.destinations.start_location_and_scale.latitude),
            lng: Number.parseFloat(props.destinations.start_location_and_scale.longitude)
        }}
       
        on
    >
        <FusionTablesLayer
      options={{
        query: {
            select: 'geometry',
            from: `1N2LBk4JHwWpOY4d9fobIn27lfnZ5MDy-NoqqRpk`,
            where: "ISO_2DIGIT IN ('RU')"
        },
        suppressInfoWindows: true,
        styles: [{
            polygonOptions: {
              fillColor: '#00FFFF',
              fillOpacity: 0.1
            }}]
      }}
    >
            </FusionTablesLayer>
        {props.destinationPages.map((item, index) => {
            let url = i.Utils.locUrl(props.urlBuilder ? props.urlBuilder(item) : "");
            let lat = Number.parseFloat(item.location.latitude);
            let lng = Number.parseFloat(item.location.longitude);
            return (
                <div>
                    <InfoBox
                        defaultPosition={new window.google.maps.LatLng(lat, lng)}
                        options={{ closeBoxURL: ``, enableEventPropagation: true }}
                    >
                        <div style={{ backgroundColor: `white`, opacity: 0.75, padding: `5px` }}>
                            <div style={{ fontSize: `12px`, fontColor: `#08233B` }}>
                                {item.name}
                            </div>
                        </div>
                    </InfoBox>
                    <InfoWindowMap
                        item={item}
                        key={index}
                        title={item.name}
                        position={{ lat: lat, lng: lng }}
                        url={url}
                    />
                </div>
            )
        })}
    </GoogleMap>
)

class Destinations extends Component {

    constructor(props) {
        super(props);

    }

    render() {
        let destinationPages = i.Utils.sortByIndex(Session.model.destinationPages);
        return (
            <BasePage data={Session.model.destinations}>
                <i.PureGridProvider>
                    <i.Container>
                        <i.Row>
                            <i.Col>
                                <MapWithAMarker
                                    urlBuilder={i.Utils.createDestinationUrl}
                                    destinationPages={destinationPages}
                                    destinations={Session.model.destinations}
                                />
                            </i.Col>
                        </i.Row>
                        <i.Row>
                            <i.Col>
                                <h2>{Session.model.home.destinations}</h2>
                                <c.CardsList items={destinationPages} urlBuilder={i.Utils.createDestinationUrl} />               
                            </i.Col>
                        </i.Row>
                    </i.Container>
                </i.PureGridProvider>
            </BasePage>
        );
    }
}

export default Destinations;